import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    paddingTop: 20,
    paddingHorizontal: 23,
  },

  mainContainer: {
    flex: 1,
    fontSize: 10,
  },

  // Header
  header: {
    display: 'flex',
    flexDirection: 'column',
  },

  viewOneHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },

  logo: { width: 174, height: 80 },

  viewRightOneHeader: {
    display: 'flex',
    flexDirection: 'column',
  },

  viewLine: {
    height: 1,
    backgroundColor: '#DEE1E2',
    marginTop: 5,
    marginBottom: 12,
  },

  viewTwoHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    gap: 4,
  },

  viewLeftTwoHeader: {
    display: 'flex',
    flexDirection: 'column',
  },

  viewRightTwoHeader: {
    display: 'flex',
    flexDirection: 'column',
    width: '220px',
    gap: '4px',
  },

  viewItemHeaderOne: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: '2px',
  },

  viewItemHeaderTwo: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '8px',
  },

  titleTitle: {
    fontSize: 30,
    fontWeight: 500,
  },

  textLabel: {
    fontSize: 10,
    fontWeight: 700,
    justifyContent: 'flex-start',
  },

  textContent: {
    fontSize: 10,
    fontWeight: 500,
  },

  textSubTitle: {
    fontSize: 10,
    fontWeight: 500,
    color: '#8C959A',
  },

  textLink: {
    textDecoration: 'underline',
    color: '#007bff',
  },

  viewLabelTwo: {
    width: '103px',
    textAlign: 'right',
  },

  viewTotal: {
    backgroundColor: '#F4F5F5',
    height: 20,
  },

  logoContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },

  imageSignature: { width: 30, height: 30, objectFit: 'cover' },

  infoStore: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    flexDirection: 'column',
    gap: 4,
  },

  title: {
    fontSize: 19,
    fontWeight: 700,
    lineHeight: '23px',
    textTransform: 'uppercase',
    marginBottom: 10,
    marginTop: 7,
  },

  subTitle: {
    fontSize: 13,
    fontWeight: 700,
    lineHeight: '16px',
  },

  infoValue: {
    fontSize: 11,
    lineHeight: '14px',
    fontWeight: 400,
  },

  infoInvoice: {
    marginTop: 48,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    flexDirection: 'column',
    gap: 4,
  },

  infoStaff: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },

  infoInvoiceItem: {
    display: 'flex',
    width: 200,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 10,
  },

  // Table
  tableContainer: {
    marginTop: 5,
    overflow: 'hidden',
  },

  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#C7ECFF',
    gap: 5,
    paddingVertical: 6,
    paddingHorizontal: 4,
    marginTop: 10,
  },

  tableRow: {
    flexDirection: 'row',
    gap: 5,
    paddingVertical: 6,
    paddingHorizontal: 4,
    borderBottomWidth: 1,
    borderBottomColor: '#DEE1E2',
  },

  viewTitleLeft: {
    width: '50%',
    alignSelf: 'flex-end',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    borderBottomWidth: 1,
    gap: 5,
    borderBottomColor: '#DFE4EA',
    paddingVertical: 6,
    paddingHorizontal: 4,
  },

  tableCellType: {
    fontSize: 10,
    textAlign: 'left',
    fontWeight: 500,
    width: '15%',
  },

  tableCell: {
    fontSize: 10,
    textAlign: 'left',
    fontWeight: 500,
    width: '20%',
  },

  tableCellName: {
    width: '30%',
    fontSize: 10,
    textAlign: 'left',
    fontWeight: 700,
  },

  tableHeaderCell: {
    fontSize: 10,
    fontWeight: 700,
    width: '20%',
  },

  tableHeaderCellType: {
    fontSize: 10,
    fontWeight: 700,
    width: '15%',
  },

  tableHeaderCells: {
    width: '30%',
    fontSize: 10,
    fontWeight: 700,
  },

  // viewAdjustmentItem

  viewAdjustment: {
    flex: 1,
  },

  viewAdjustmentContainer: {
    marginTop: 10,
    flexDirection: 'column',
    gap: 4,
  },

  viewAdjustmentItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 5,
    alignItems: 'center',
  },

  viewAdjustmentLabel: {
    fontSize: 10,
    fontWeight: 600,
  },

  viewTotalContainer: {
    flexDirection: 'row',
    marginTop: 10,
    gap: 150,
  },

  viewTotalContent: {
    flex: 1,
  },

  viewLeft: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignSelf: 'flex-end',
  },

  viewSignature: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 10,
    gap: 150,
  },

  viewSignatureClient: {
    flexDirection: 'column',
    width: '50%',
    gap: 5,
    borderBottomWidth: 1,
    borderBottomColor: '#DFE4EA',
    paddingBottom: 4,
  },

  viewNoteContent: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 8,
  },
});
